// Common
import common from './locales.json';

// Login
import { locales as login } from '../../pages/Login/locales';
import { locales as register } from '../../pages/Register/locales';
// import { locales as login_qr } from '../../pages/LoginQr/locales';
import { locales as forgetpassword } from '../../pages/ForgetPassword/locales';
import { locales as dashboard } from '../../pages/Dashboard/locales';
import { locales as notifications } from '../../containers/Notifications/locales';
import { locales as tasks } from '../../containers/Tasks/locales';
import { locales as tasksetiqa } from '../../containers/TasksEtiqa/locales';
import { locales as add_task } from '../../containers/Tasks/AddTask/locales';
import { locales as edit_task } from '../../containers/Tasks/EditTask/locales';
import { locales as add_task_etiqa } from '../../containers/TasksEtiqa/AddTaskEtiqa/locales';
import { locales as edit_task_etiqa } from '../../containers/TasksEtiqa/EditTaskEtiqa/locales';
import { locales as calendar } from '../../containers/Calendar/locales';
import { locales as jobs } from '../../containers/Jobs/locales';
import { locales as add_job } from '../../containers/Jobs/AddJobs/locales';
import { locales as edit_job } from '../../containers/Jobs/EditJob/locales';
import { locales as checklist } from '../../containers/Checklists/locales';
import { locales as add_checklist } from '../../containers/Checklists/AddChecklist/locales';
import { locales as edit_checklist } from '../../containers/Checklists/EditChecklist/locales';
import { locales as supports } from '../../containers/Supports/locales';
import { locales as add_support } from '../../containers/Supports/AddSupport/locales';
import { locales as edit_support } from '../../containers/Supports/EditSupport/locales';
import { locales as pools } from '../../containers/Pools/locales';
import { locales as add_pool } from '../../containers/Pools/AddPool/locales';
import { locales as edit_pool } from '../../containers/Pools/EditPool/locales';
import { locales as qrcode } from '../../containers/QRCodes/locales';
import { locales as users } from '../../containers/Users/locales';
import { locales as add_user } from '../../containers/Users/AddUser/locales';
import { locales as edit_user } from '../../containers/Users/EditUser/locales';
import { locales as locations } from '../../containers/Locations/locales';
import { locales as add_location } from '../../containers/Locations/AddLocation/locales';
import { locales as edit_location } from '../../containers/Locations/EditLocation/locales';
import { locales as materials } from '../../containers/Materials/locales';
import { locales as add_material } from '../../containers/Materials/AddMaterial/locales';
import { locales as edit_material } from '../../containers/Materials/EditMaterial/locales';
import { locales as warehouses } from '../../containers/Warehouses/locales';
import { locales as add_warehouse } from '../../containers/Warehouses/AddWarehouses/locales';
import { locales as edit_warehouse } from '../../containers/Warehouses/EditWarehouses/locales';
import { locales as equipments } from '../../containers/Equipments/locales';
import { locales as add_equipment } from '../../containers/Equipments/AddEquipment/locales';
import { locales as edit_equipment } from '../../containers/Equipments/EditEquipment/locales';
import { locales as equipment_trees } from '../../containers/EquipmentTrees/locales'
import { locales as add_equipment_trees } from '../../containers/EquipmentTrees/AddEquipmentTrees/locales'
import { locales as edit_equipment_trees } from '../../containers/EquipmentTrees/EditEquipmentTrees/locales'
import { locales as ownprojects } from '../../containers/OwnProjects/locales'
import { locales as add_ownprojects } from '../../containers/OwnProjects/AddOwnProject/locales'
import { locales as edit_ownprojects } from '../../containers/OwnProjects/EditOwnProject/locales'
import { locales as own_projects_excel_import } from '../../containers/OwnProjectExcelImport/locales'
import { locales as own_projects_import_update } from '../../containers/OwnProjectImportUpdate/locales'
import { locales as equipments_excel_import } from '../../containers/EquipmentExcelImport/locales'
import { locales as reports } from '../../containers/Reports/locales'
import { locales as manager_reports } from '../../containers/ManagerReports/locales'
import { locales as control_tasks_reports } from '../../containers/ControlTasksReports/locales'
import { locales as projects } from '../../containers/Projects/locales'
import { locales as add_projects } from '../../containers/Projects/AddProject/locales'
import { locales as edit_projects } from '../../containers/Projects/EditProject/locales'
import { locales as messages } from '../../containers/Messages/locales'
import { locales as servicefirms } from '../../containers/ServiceFirms/locales'
import { locales as add_servicefirms } from '../../containers/ServiceFirms/AddServiceFirm/locales'
import { locales as edit_servicefirms } from '../../containers/ServiceFirms/EditServiceFirm/locales'
import { locales as roles } from '../../containers/Roles/locales'
import { locales as add_roles } from '../../containers/Roles/AddRole/locales'
import { locales as role_pages } from '../../containers/RolePages/locales'
import { locales as energy_map } from '../../containers/EnergyMap/locales'
import { locales as add_transfer_task } from '../../containers/Tasks/AddTransferTask/locales'
import { locales as add_control_task } from '../../containers/Tasks/AddControlTask/locales'
import { locales as edit_transfer_task } from '../../containers/Tasks/EditTransferTask/locales'
import { locales as invoices } from '../../containers/Invoices/locales'
import { locales as add_invoice } from '../../containers/Invoices/AddInvoice/locales'
import { locales as edit_invoice } from '../../containers/Invoices/EditInvoice/locales'
import { locales as add_tenant_task } from '../../containers/Tasks/AddTenantTask/locales'
import { locales as edit_tenant_task } from '../../containers/Tasks/EditTenantTask/locales'
import { locales as contracts } from '../../containers/Contracts/locales'
import { locales as add_contract } from '../../containers/Contracts/AddContract/locales'
import { locales as edit_contract } from '../../containers/Contracts/EditContract/locales'
import { locales as manager_tasks } from '../../containers/ManagerTasks/locales';
import { locales as add_manager_task } from '../../containers/ManagerTasks/AddManagerTask/locales';
import { locales as edit_manager_task } from '../../containers/ManagerTasks/EditManagerTask/locales';
import { locales as invoice_tasks } from '../../containers/InvoiceTasks/locales';
import { locales as bom } from '../../containers/BOM/locales';

// Turkish
common['tr'].login = login['tr'];
common['tr'].register = register['tr'];
// common['tr'].login_qr = login_qr['tr'];
common['tr'].forgetpassword = forgetpassword['tr'];
common['tr'].dashboard = dashboard['tr'];
common['tr'].notifications = notifications['tr'];
common['tr'].tasks = tasks['tr'];
common['tr'].tasksetiqa = tasksetiqa['tr'];
common['tr'].add_task = add_task['tr'];
common['tr'].edit_task = edit_task['tr'];
common['tr'].edit_task_etiqa = edit_task_etiqa['tr'];
common['tr'].add_task_etiqa = add_task_etiqa['tr'];
common['tr'].calendar = calendar['tr'];
common['tr'].jobs = jobs['tr'];
common['tr'].add_job = add_job['tr'];
common['tr'].edit_job = edit_job['tr'];
common['tr'].checklist = checklist['tr'];
common['tr'].add_checklist = add_checklist['tr'];
common['tr'].edit_checklist = edit_checklist['tr'];
common['tr'].supports = supports['tr'];
common['tr'].add_support = add_support['tr'];
common['tr'].edit_support = edit_support['tr'];
common['tr'].pools = pools['tr'];
common['tr'].add_pool = add_pool['tr'];
common['tr'].edit_pool = edit_pool['tr'];
common['tr'].qrcode = qrcode['tr'];
common['tr'].users = users['tr'];
common['tr'].add_user = add_user['tr'];
common['tr'].edit_user = edit_user['tr'];
common['tr'].locations = locations['tr'];
common['tr'].add_location = add_location['tr'];
common['tr'].edit_location = edit_location['tr'];
common['tr'].materials = materials['tr'];
common['tr'].add_material = add_material['tr'];
common['tr'].edit_material = edit_material['tr'];
common['tr'].warehouses = warehouses['tr'];
common['tr'].add_warehouse = add_warehouse['tr'];
common['tr'].edit_warehouse = edit_warehouse['tr'];
common['tr'].equipments = equipments['tr'];
common['tr'].add_equipment = add_equipment['tr'];
common['tr'].edit_equipment = edit_equipment['tr'];
common['tr'].equipment_trees = equipment_trees['tr'];
common['tr'].add_equipment_trees = add_equipment_trees['tr'];
common['tr'].edit_equipment_trees = edit_equipment_trees['tr'];
common['tr'].ownprojects = ownprojects['tr'];
common['tr'].add_ownprojects = add_ownprojects['tr'];
common['tr'].edit_ownprojects = edit_ownprojects['tr'];
common['tr'].own_projects_excel_import = own_projects_excel_import['tr'];
common['tr'].own_projects_import_update = own_projects_import_update['tr'];
common['tr'].equipments_excel_import = equipments_excel_import['tr'];
common['tr'].reports = reports['tr'];
common['tr'].manager_reports = manager_reports['tr'];
common['tr'].control_tasks_reports = control_tasks_reports['tr'];
common['tr'].projects = projects['tr'];
common['tr'].add_projects = add_projects['tr'];
common['tr'].edit_projects = edit_projects['tr'];
common['tr'].messages = messages['tr'];
common['tr'].servicefirms = servicefirms['tr'];
common['tr'].add_servicefirms = add_servicefirms['tr'];
common['tr'].edit_servicefirms = edit_servicefirms['tr'];
common['tr'].roles = roles['tr'];
common['tr'].add_roles = add_roles['tr'];
common['tr'].role_pages = role_pages['tr'];
common['tr'].energy_map = energy_map['tr'];
common['tr'].add_transfer_task = add_transfer_task['tr'];
common['tr'].add_control_task = add_control_task['tr'];
common['tr'].invoices = invoices['tr'];
common['tr'].add_invoice = add_invoice['tr'];
common['tr'].edit_invoice = edit_invoice['tr'];
common['tr'].add_tenant_task = add_tenant_task['tr'];
common['tr'].edit_tenant_task = edit_tenant_task['tr'];
common['tr'].edit_transfer_task = edit_transfer_task['tr'];
common['tr'].contracts = contracts['tr'];
common['tr'].add_contract= add_contract['tr'];
common['tr'].edit_contract= edit_contract['tr'];
common['tr'].manager_tasks= manager_tasks['tr'];
common['tr'].add_manager_task= add_manager_task['tr'];
common['tr'].edit_manager_task= edit_manager_task['tr'];
common['tr'].invoice_tasks= invoice_tasks['tr'];
common['tr'].bom = bom['tr'];

// English
common['en'].login = login['en'];
common['en'].register = register['en'];
// common['tr'].login_qr = login_qr['en'];
common['en'].forgetpassword = forgetpassword['en'];
common['en'].dashboard = dashboard['en'];
common['en'].notifications = notifications['en'];
common['en'].tasks = tasks['en'];
common['en'].tasksetiqa = tasksetiqa['en'];
common['en'].add_task = add_task['en'];
common['en'].edit_task = edit_task['en'];
common['en'].edit_task_etiqa = edit_task_etiqa['en'];
common['en'].add_task_etiqa = add_task_etiqa['en'];
common['en'].calendar = calendar['en'];
common['en'].jobs = jobs['en'];
common['en'].add_job = add_job['en'];
common['en'].edit_job = edit_job['en'];
common['en'].checklist = checklist['en'];
common['en'].add_checklist = add_checklist['en'];
common['en'].edit_checklist = edit_checklist['en'];
common['en'].supports = supports['en'];
common['en'].add_support = add_support['en'];
common['en'].edit_support = edit_support['en'];
common['en'].pools = pools['en'];
common['en'].add_pool = add_pool['en'];
common['en'].edit_pool = edit_pool['en'];
common['en'].qrcode = qrcode['en'];
common['en'].users = users['en'];
common['en'].add_user = add_user['en'];
common['en'].edit_user = edit_user['en'];
common['en'].locations = locations['en'];
common['en'].add_location = add_location['en'];
common['en'].edit_location = edit_location['en'];
common['en'].materials = materials['en'];
common['en'].add_material = add_material['en'];
common['en'].edit_material = edit_material['en'];
common['en'].warehouses = warehouses['en'];
common['en'].add_warehouse = add_warehouse['en'];
common['en'].edit_warehouse = edit_warehouse['en'];
common['en'].equipments = equipments['en'];
common['en'].add_equipment = add_equipment['en'];
common['en'].edit_equipment = edit_equipment['en'];
common['en'].equipment_trees = equipment_trees['en'];
common['en'].add_equipment_trees = add_equipment_trees['en'];
common['en'].edit_equipment_trees = edit_equipment_trees['en'];
common['en'].ownprojects = ownprojects['en'];
common['en'].add_ownprojects = add_ownprojects['en'];
common['en'].edit_ownprojects = edit_ownprojects['en'];
common['en'].own_projects_excel_import = own_projects_excel_import['en'];
common['en'].own_projects_import_update = own_projects_import_update['en'];
common['en'].equipments_excel_import = equipments_excel_import['en'];
common['en'].reports = reports['en'];
common['en'].manager_reports = manager_reports['en'];
common['en'].control_tasks_reports = control_tasks_reports['en'];
common['en'].projects = projects['en'];
common['en'].add_projects = add_projects['en'];
common['en'].edit_projects = edit_projects['en'];
common['en'].messages = messages['en'];
common['en'].servicefirms = servicefirms['en'];
common['en'].add_servicefirms = add_servicefirms['en'];
common['en'].edit_servicefirms = edit_servicefirms['en'];
common['en'].roles = roles['en'];
common['en'].add_roles = add_roles['en'];
common['en'].role_pages = role_pages['en'];
common['en'].energy_map = energy_map['en'];
common['en'].add_transfer_task = add_transfer_task['en'];
common['tr'].add_control_task = add_control_task['tr'];
common['en'].invoices = invoices['en'];
common['en'].add_invoice = add_invoice['en'];
common['en'].edit_invoice = edit_invoice['en'];
common['en'].add_tenant_task = add_tenant_task['en'];
common['en'].edit_tenant_task = edit_tenant_task['en'];
common['en'].edit_transfer_task = edit_transfer_task['en'];
common['en'].contracts = contracts['en'];
common['en'].add_contract= add_contract['en'];
common['en'].edit_contract= edit_contract['en'];
common['en'].manager_tasks= manager_tasks['en'];
common['en'].add_manager_task= add_manager_task['en'];
common['en'].edit_manager_task= edit_manager_task['en'];
common['en'].invoice_tasks= invoice_tasks['en'];
common['en'].bom = bom['en'];

//Boşnakça
common['bs'].login = login['bs'];
common['bs'].register = register['bs'];
// common['tr'].login_qr = login_qr['en'];
common['bs'].forgetpassword = forgetpassword['bs'];
common['bs'].dashboard = dashboard['bs'];
common['bs'].notifications = notifications['bs'];
common['bs'].tasks = tasks['bs'];
common['bs'].tasksetiqa = tasksetiqa['bs'];
common['bs'].add_task = add_task['bs'];
common['bs'].edit_task_etiqa = edit_task_etiqa['bs'];
common['bs'].add_task_etiqa = add_task_etiqa['bs'];
common['bs'].edit_task = edit_task['bs'];
common['bs'].calendar = calendar['bs'];
common['bs'].jobs = jobs['bs'];
common['bs'].add_job = add_job['bs'];
common['bs'].edit_job = edit_job['bs'];
common['bs'].checklist = checklist['bs'];
common['bs'].add_checklist = add_checklist['bs'];
common['bs'].edit_checklist = edit_checklist['bs'];
common['bs'].supports = supports['bs'];
common['bs'].add_support = add_support['bs'];
common['bs'].edit_support = edit_support['bs'];
common['bs'].pools = pools['bs'];
common['bs'].add_pool = add_pool['bs'];
common['bs'].edit_pool = edit_pool['bs'];
common['bs'].qrcode = qrcode['bs'];
common['bs'].users = users['bs'];
common['bs'].add_user = add_user['bs'];
common['bs'].edit_user = edit_user['bs'];
common['bs'].locations = locations['bs'];
common['bs'].add_location = add_location['bs'];
common['bs'].edit_location = edit_location['bs'];
common['bs'].materials = materials['bs'];
common['bs'].add_material = add_material['bs'];
common['bs'].edit_material = edit_material['bs'];
common['bs'].warehouses = warehouses['bs'];
common['bs'].add_warehouse = add_warehouse['bs'];
common['bs'].edit_warehouse = edit_warehouse['bs'];
common['bs'].equipments = equipments['bs'];
common['bs'].add_equipment = add_equipment['bs'];
common['bs'].edit_equipment = edit_equipment['bs'];
common['bs'].equipment_trees = equipment_trees['bs'];
common['bs'].add_equipment_trees = add_equipment_trees['bs'];
common['bs'].edit_equipment_trees = edit_equipment_trees['bs'];
common['bs'].ownprojects = ownprojects['bs'];
common['bs'].add_ownprojects = add_ownprojects['bs'];
common['bs'].edit_ownprojects = edit_ownprojects['bs'];
common['bs'].own_projects_excel_import = own_projects_excel_import['bs'];
common['bs'].own_projects_import_update = own_projects_import_update['bs'];
common['bs'].equipments_excel_import = equipments_excel_import['bs'];
common['bs'].reports = reports['bs'];
common['bs'].manager_reports = manager_reports['bs'];
common['bs'].control_tasks_reports = control_tasks_reports['bs'];
common['bs'].projects = projects['bs'];
common['bs'].add_projects = add_projects['bs'];
common['bs'].edit_projects = edit_projects['bs'];
common['bs'].messages = messages['bs'];
common['bs'].servicefirms = servicefirms['bs'];
common['bs'].add_servicefirms = add_servicefirms['bs'];
common['bs'].edit_servicefirms = edit_servicefirms['bs'];
common['bs'].roles = roles['bs'];
common['bs'].add_roles = add_roles['bs'];
common['bs'].role_pages = role_pages['bs'];
common['bs'].energy_map = energy_map['bs'];
common['bs'].add_transfer_task = add_transfer_task['bs'];
common['bs'].add_control_task = add_control_task['bs'];
common['bs'].invoices = invoices['bs'];
common['bs'].add_invoice = add_invoice['bs'];
common['bs'].edit_invoice = edit_invoice['bs'];
common['bs'].add_tenant_task = add_tenant_task['bs'];
common['bs'].edit_tenant_task = edit_tenant_task['bs'];
common['bs'].edit_transfer_task = edit_transfer_task['bs'];
common['bs'].contracts = contracts['bs'];
common['bs'].add_contract= add_contract['bs'];
common['bs'].edit_contract= edit_contract['bs'];
common['bs'].manager_tasks= manager_tasks['bs'];
common['bs'].add_manager_task= add_manager_task['bs'];
common['bs'].edit_manager_task= edit_manager_task['bs'];
common['bs'].invoice_tasks= invoice_tasks['bs'];
common['bs'].bom = bom['bs'];
export { common };
